import { Logo } from '@shared/assets/icons/shared/logo';
import { Instagram, Location } from 'iconsax-react';
import { FacebookIcon, LinkedinIcon, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className='py-28 pb-0 px-24 mt-10 border-t border-gray-50'>
      <div className='flex gap-10'>
        <div className='w/5/12'>
          <Logo
            open={true}
            dark={true}
          />
          <p
            className='text-primary-1000 font-light text-base font-sans my-5'
            style={{ color: '#6f6c90' }}
          >
            Lorem ipsum dolor sit <br /> amet consectetur adipiscing elit
            aliquam
          </p>
          <div className='flex gap-3'>
            <a
              target='_blank'
              href='https://www.facebook.com/share/1CYkhsRpE7/?mibextid=wwXIfr'
            >
              <FacebookIcon
                fill='#5B31AA'
                size={18}
              />
            </a>
            <a
              target='_blank'
              href='https://www.instagram.com/ticlick.crm?igsh=MWpvMG01bm8wNnljaA=='
            >
              <Instagram
                fill='#5B31AA'
                size={18}
                variant='Bold'
              />
            </a>
            <a
              target='_blank'
              href='https://www.linkedin.com/company/ticlick/'
            >
              <LinkedinIcon
                fill='#5B31AA'
                size={18}
              />
            </a>
          </div>
        </div>
        <div className='w-2/12'>
          <h3
            className='font-sans font-bold text-xl mb-3'
            style={{ color: '#170F49' }}
          >
            Product
          </h3>
          <ul>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Features
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Pricing
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Case studies
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Reviews
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Updates
            </li>
          </ul>
        </div>
        <div className='w-2/12'>
          <h3
            className='font-sans font-bold text-xl mb-3'
            style={{ color: '#170F49' }}
          >
            Company
          </h3>
          <ul>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              About
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Contact us
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Careers
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Culture
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Blog
            </li>
          </ul>
        </div>
        <div className='w-2/12'>
          <h3
            className='font-sans font-bold text-xl mb-3'
            style={{ color: '#170F49' }}
          >
            Support
          </h3>
          <ul>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Getting started
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Help center
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Server status
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Report a bug
            </li>
            <li
              className='mb-4 font-sans font-light text-lg'
              style={{ color: '#6f6c90' }}
            >
              Chat support
            </li>
          </ul>
        </div>
        <div className='w-2/12'>
          <h3
            className='font-sans font-bold text-xl mb-3'
            style={{ color: '#170F49' }}
          >
            Contacts us
          </h3>
          <ul>
            <li
              className='mb-4 font-sans font-light text-lg flex items-start gap-2'
              style={{ color: '#6f6c90' }}
            >
              <Mail
                size={18}
                className='mt-1'
              />
              contact@company.com
            </li>
            <li
              className='mb-4 font-sans font-light text-lg flex items-start gap-2'
              style={{ color: '#6f6c90' }}
            >
              <Phone
                size={18}
                className='mt-1'
              />
              (414) 687 - 5892
            </li>
            <li
              className='mb-4 font-sans font-light text-lg flex items-start gap-2'
              style={{ color: '#6f6c90' }}
            >
              <Location
                size={18}
                className='mt-1'
              />
              794 Mcallister St <br /> San Francisco, 94102
            </li>
          </ul>
        </div>
      </div>
      <div className='py-6 px-6 mt-20 w-12/12 flex justify-between items-center border-t border-gray-50'>
        <p
          className='font-sans font-extralight text-lg mb-3'
          style={{ color: '#6F6C90' }}
        >
          Copyright © 2022 BRIX Templates
        </p>
        <p
          className='font-sans font-extralight text-lg mb-3'
          style={{ color: '#6F6C90' }}
        >
          All Rights Reserved |
          <a
            href='#'
            className='mx-2'
            style={{ textDecoration: 'underline' }}
          >
            Terms and Conditions{' '}
          </a>{' '}
          |
          <a
            href='#'
            className='mx-2'
            style={{ textDecoration: 'underline' }}
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
